
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { SettingsRichTextV1Field } from "../settings-rich-text-v1.class";
import { FieldsStandardRemoveMenuItem, FieldsMenuMoveDown, FieldsMenuMoveUp, FieldsMenuReallyRemove } from '../../../settings-field-menu/fields.menu';
import { FormsFieldItemMenuClick } from '../../../settings-field-menu/field-menu-item.model';

@Component({
    selector: 'form-field-settings-rich-text-v1',
    templateUrl: './settings-rich-text-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsRichTextV1FieldComponent implements OnInit, OnChanges {
    @Input() field: SettingsRichTextV1Field;
    @Output() fieldChange = new EventEmitter<SettingsRichTextV1Field>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();

    public placeholder: string = "Name of the Rich Text block field";
    public form: FormGroup = new FormGroup({});
    public fieldMenu: Array<ThreeDotsMenuItem> = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        // this.updateMenuItems();
    }
    

    // maybe not needed
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.field){
            // this.updateMenuItems();
            this.cdr.markForCheck();
        }
    }

    // Update creating new objects to ensure change detection    
    onMandatoryChange(mandatory: boolean) {

        this.field = this.field.update({ mandatory: mandatory});
        this.emit(this.field);
    }

    onFieldChange(labelText: string) {
        this.emit(this.field.update({ label: labelText}));
    }

    onMenuClick(key: string) {
        // see ThreeDotsMenuItem interface definition to see how works this confirmation remove
        switch(key) {
            case "confirmation-remove":
                this.fieldMenu = [FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove];
                break;
            case "dismiss-really-remove": // pseudo key to return to basic menu
                this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];
                break;
            default:
                const itemClicked: FormsFieldItemMenuClick = {key: key, field: this.field}
                this.menuClick.emit(itemClicked);
        }
    }

    private emit(updatedField:SettingsRichTextV1Field): void {
        this.fieldChange.emit(updatedField);
    }

    // private updateMenuItems(){
    //     this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp ];
    //     // if(this.field.position == 1 ){
    //     //     this.fieldMenu = (this.total == 1) ? [...FieldsStandardRemoveMenuItem] : [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown]
    //     // } else {
    //     //     this.fieldMenu =  (this.field.position == this.total
    //     //         ? [...FieldsStandardRemoveMenuItem, FieldsMenuMoveUp]
    //     //         : [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp ]);
    //     // }
    // }

}
